// Session storage util with 12h expiration persisted in localStorage.
// Keeps sessions alive across tab closes / browser restarts on the same device,
// but auto-expires after DEFAULT_TTL_MS to avoid infinite sessions.

const DEFAULT_TTL_MS = 12 * 60 * 60 * 1000; // 12 hours

export function setSession(key, value, ttlMs = DEFAULT_TTL_MS) {
  try {
    const payload = { value, expiresAt: Date.now() + ttlMs };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch {
    /* localStorage disabled — silently fallback to in-memory */
  }
}

export function getSession(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const payload = JSON.parse(raw);
    if (!payload || typeof payload !== "object" || !("expiresAt" in payload)) {
      // Legacy value written by older code without expiry → treat as missing.
      localStorage.removeItem(key);
      return null;
    }
    if (Date.now() > payload.expiresAt) {
      localStorage.removeItem(key);
      return null;
    }
    return payload.value;
  } catch {
    return null;
  }
}

export function clearSession(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* noop */
  }
}
